module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Combined (sum of chain difficulties) expected difficulty based on hashrate versus actual difficulty.\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-difficulty-expected"
    }
  })]), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-458f1d36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/difficulty-expected.vue
// module id = 540
// module chunks = 1